
import { mapGetters } from 'vuex'
import { EFilter } from '@/helpers/enums'

const DEFAULT_FILTERS = {
  textSearchFilter: true
}

export default {
  name: 'SearchPanel',

  props: {
    mobile: Boolean,
    searchPools: Boolean,
    searchLocations: Boolean,
    searchWorkPreference: Boolean,
    searchHours: Boolean,
    searchDuration: Boolean,
    searchClosed: Boolean
  },

  data() {
    return {
      openFilters: { ...DEFAULT_FILTERS }
    }
  },

  computed: {
    ...mapGetters({
      categorizedPoolsList: 'filters/categorizedPoolsList',
      orphanPoolsList: 'filters/orphanPoolsList',
      preSelectCountry: 'preSelectCountry'
    }),

    filters() {
      return [
        {
          id: 'textSearchFilter',
          component: () => import('@/components/app/filters/textSearch.vue'),
          condition: this.mobile || !this.mobile,
          title: this.$t('talent.project.search.text.title')
        },
        {
          id: 'poolCategoriesFilter',
          component: () => import('@/components/app/filters/poolCategories.vue'),
          condition: this.showPoolCategoriesFilter,
          title: this.$t('talent.project.search.pools.title')
        },
        {
          id: 'locationsFilter',
          component: () => import('@/components/app/filters/location.vue'),
          condition: this.searchLocations,
          title: this.$t('talent.project.search.location.title')
        },
        {
          id: 'workPrefFilter',
          component: () => import('@/components/app/filters/workPreference.vue'),
          condition: this.searchWorkPreference,
          title: this.$t('talent.project.search.work.preference.title')
        },
        {
          id: 'hoursFilter',
          component: () => import('@/components/app/filters/hours.vue'),
          condition: this.searchHours,
          title: this.$t('talent.project.search.hours.title')
        },
        {
          id: 'durationFilter',
          component: () => import('@/components/app/filters/duration.vue'),
          condition: this.searchDuration,
          title: this.$t('talent.project.search.duration.title')
        },
        {
          id: 'includeClosedFilter',
          component: () => import('@/components/app/filters/includeClosed.vue'),
          condition: this.searchClosed,
          title: this.$t('talent.project.search.include.closed.title')
        }
      ].filter((item) => item.condition)
    },

    showPoolCategoriesFilter() {
      return this.searchPools && (this.categorizedPoolsList.length || this.orphanPoolsList.length)
    }
  },

  watch: {
    '$route.query': {
      immediate: true,
      handler(data) {
        for (const item of Object.keys(data)) {
          switch (item) {
            case EFilter.TEXT:
              this.$set(this.openFilters, 'textSearchFilter', true)
              break
            case EFilter.POOLS:
              this.$set(this.openFilters, 'poolCategoriesFilter', true)
              break
            case EFilter.LOCATION:
              this.$set(this.openFilters, 'locationsFilter', true)
              break
            case EFilter.HOURS:
              this.$set(this.openFilters, 'hoursFilter', true)
              break
            case EFilter.DURATION:
              this.$set(this.openFilters, 'durationFilter', true)
              break
            case EFilter.WORK_PREFS:
              this.$set(this.openFilters, 'workPrefFilter', true)
              break
            case EFilter.OPEN_ONLY:
              this.$set(this.openFilters, 'includeClosedFilter', true)
              break
          }
        }
      }
    }
  },

  methods: {
    cleanupFilters() {
      this.$router.push({ query: {} })
      this.openFilters = { ...DEFAULT_FILTERS }
    },

    openLoader() {
      this.$triggerLoader('ACTION', true)
    },

    closeLoader() {
      this.$triggerLoader('ACTION', false)
    }
  }
}
